import Hero from '@/components/Hero'
import NewsFeed from '@/components/NewsFeed'
import GameGrid from '@/components/GameGrid'
import Footer from '@/components/Footer'
import ContactSection from '@/components/ContactSection'
import {
  CommunitySection,
  DiscordCta,
  TeamSection,
  ConductSection,
} from '@/components/CommunitySections'
import type { CommunityData } from '@/useCommunity'

/**
 * The hub landing page — single-page scroll layout:
 * hero → games → community → Discord → conduct teaser → team → news → contact → footer.
 * The full Code of Conduct lives on its own /conduct route.
 */
export default function Home({ community }: { community: CommunityData }) {
  return (
    <>
      <main>
        <Hero social={community.social} />
        <GameGrid />
        <CommunitySection />
        <DiscordCta discordInvite={community.discordInvite} />
        <ConductSection conduct={community.conduct} />
        <TeamSection leadership={community.leadership} />
        <NewsFeed />
        <ContactSection community={community} />
      </main>
      <Footer social={community.social} />
    </>
  )
}
